import { render, staticRenderFns } from "./ActivateModal.vue?vue&type=template&id=1f9d6808&scoped=true"
import script from "./ActivateModal.vue?vue&type=script&lang=js"
export * from "./ActivateModal.vue?vue&type=script&lang=js"
import style0 from "./ActivateModal.vue?vue&type=style&index=0&id=1f9d6808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d6808",
  null
  
)

export default component.exports